import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'

import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card'

import CommentForm from './CommentForm'
import CommentList from './CommentList'
import AddButton from './AddButton'
import Section from 'components/Section'

import { objectComments } from 'selectors/comments'

import commentActions from 'actions/commentActions'
import dataActions from 'actions/dataActions'

let select = (state, props) => ({
	mode: state.commentBuffer.mode
  , comments: objectComments(state, props)
})

export class Comments extends Component {
	render(){
		let { props } = this
		let commentQuery = (window.location.search.indexOf("comments") == -1)? false : true
		return(
			<Section
				id="comments"
				title="Comments"
				badge={props.comments.length}
				rightButton={<AddButton objectID={this.props.objectID} />}
				needBeExpanded={commentQuery}
			>
				{ (props.mode == 'new') && <CommentForm objectID={this.props.objectID} path={props.path} />}
				<CommentList objectID={this.props.objectID} path={props.path}/>
			</Section>
		)
	}
}

export default connect(select, R.mergeAll([dataActions, commentActions]))(Comments)
// Section
// 	addFunc={props.COMMENT_ADD}
// 	count={count}
// 	titleName="Comments"
// 	expanded={commentQuery || props.sections.comments}
// 	card='comments'
// 	onToogle={props.SECTION_EXPAND}
// >



// WEBPACK FOOTER //
// ./src/components/Comments/index.js